import posthog from "posthog-js";
import { POSTHOG_KEY } from "../utils/gvSecrets";
import { isProduction } from "../utils/getUrlPrefix";

posthog.init(POSTHOG_KEY, {
  autocapture: true,
  capture_pageview: true,
  session_recording: { maskAllInputs: true },
  person_profiles: "identified_only",
  loaded: (ph) => {
    if (!isProduction) {
      ph.opt_out_capturing();
    }
  },
});

export { posthog };
